import { motion } from 'framer-motion';
import { VOTE_OPTIONS, ASSETS } from '../lib/products';
import FloatingChips from '../components/FloatingChips';
import VoteSection from '../sections/VoteSection';
import Marquee from '../components/Marquee';
import Footer from '../sections/Footer';

export default function VotePage() {
  return (
    <main data-testid="vote-page" className="bg-cream min-h-screen">
      <section className="relative overflow-hidden bg-kyellow">
        <div className="absolute inset-0 opacity-[0.08] bg-[repeating-linear-gradient(135deg,transparent_0_28px,#2A1010_28px_30px)]" />
        <FloatingChips count={4} />
        <div className="relative max-w-[1500px] mx-auto px-6 md:px-14 py-16 md:py-20 grid md:grid-cols-[3fr_2fr] gap-10 items-center">
          <div>
            <p className="font-cond text-xl tracking-[0.3em] text-cocoa/70">THE FLAVOUR PORTAL</p>
            <h1 className="font-display text-[17vw] md:text-[8vw] leading-[0.85] text-cocoa mt-2">YOU PICK<br />FLAVOUR #3.</h1>
            <p className="text-base text-cocoa/80 mt-5 max-w-lg">Masala Krunch and Cheese & Herbs are locked. The third PROKRISP flavour is chosen by the people who'll eat it. One vote per person. Winner announced to the waitlist first.</p>
            <div className="flex flex-wrap gap-2 mt-6">
              {VOTE_OPTIONS.map((o) => <span key={o.id} className="rounded-full border-2 border-cocoa px-4 py-1.5 font-cond font-bold text-sm tracking-wider text-cocoa">{o.name}</span>)}
            </div>
          </div>
          <div className="relative h-72 md:h-[440px] flex items-center justify-center">
            <img src={ASSETS.soon} alt="PROKRISP Flavour #3 coming soon" className="h-full object-contain gpu chip-drift" style={{ '--r': '-3deg', '--t': '8s' }} data-testid="vote-hero-pack" />
          </div>
        </div>
      </section>
      <Marquee dark text="CAST YOUR VOTE · SALT & PEPPER · TOMATO · SWEET CHILLI · PUDINA ·" />
      <VoteSection />
      <Footer />
    </main>
  );
}
